import {Grid} from '@mui/material';
import AppGridContainer from 'main/core/AppGridContainer';
import {useWidget} from 'main/utility/hooks/useWidget';
import PropTypes from 'prop-types';
import {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {useReactToPrint} from 'react-to-print';
import {getWidgetData} from 'redux/actions';
import DocActions from './DocActions';
import DocTemplate from './DocTemplate';

const DocInvoiceWidget = ({widgetSpec, params}) => {
  const dispatch = useDispatch();
  const documentRef = useRef(null);
  const {widgetid, actions, widgettitle} = widgetSpec;

  const {widgetData, isSuccess} = useWidget(widgetid);
  const notSuccess = !isSuccess;

  useEffect(() => {
    dispatch(getWidgetData(widgetid, params));
  }, [dispatch, widgetid, params]);

  const handlePrint = useReactToPrint({
    contentRef: documentRef,
    documentTitle: widgettitle || 'Document',
  });

  return (
    <AppGridContainer>
      <Grid item xs={12} sx={{maxWidth: 900, width: '100%'}}>
        <DocActions
          actions={actions}
          widgetData={params}
          onPrint={handlePrint}
          disabled={notSuccess}
        />

        <div ref={documentRef}>
          <DocTemplate
            widgetSpec={widgetSpec}
            widgetData={widgetData}
            notSuccess={notSuccess}
          />
        </div>
      </Grid>
    </AppGridContainer>
  );
};

DocInvoiceWidget.propTypes = {
  widgetSpec: PropTypes.object.isRequired,
  params: PropTypes.object,
};

export default DocInvoiceWidget;
